import React from 'react';
import { NO_ELEMENT } from 'utils';
import styles from './styles.scss';
import cn from 'classnames';
import { Appearances } from './types';

interface ButtonTextProps extends Appearances {
  text?: string;
  isBold?: boolean;
}

export const ButtonText = ({ text, appearance = 'simpleCard', isBold }: ButtonTextProps) => {
  if (!text) {
    return NO_ELEMENT;
  }

  const isSimpleCardInverted = appearance === 'simpleCardInverted';
  const isCard = appearance === 'card';

  return (
    <p
      className={cn(styles.title, {
        [styles.bold]: isBold,
        [styles.dark]: isSimpleCardInverted || isCard,
        [styles.card]: isCard,
        [styles.medium]: isCard && isBold
      })}
    >
      {text}
    </p>
  );
};
